import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LinkStyler } from '@redis-ui/components';
import * as S from './DontHaveAnAccount.style';
import { routes } from '../../../../../../utils/constants/routes';
import { parametersQueries } from '../../../../../../queryClient/parameters/parameters.queries';
import { i18translation } from '../../../../../../locale/translations/i18NsPaths';

interface Props {
  marketPlace: string;
}
const DontHaveAnAccount = ({ marketPlace }: Props) => {
  const { systemParams } = parametersQueries.useSystemParameters();
  const { t } = useTranslation();
  const keyPrefix = i18translation.LoginScreen;

  const getSignUpLink = (): string => {
    if (marketPlace === 'aws') {
      return `${systemParams.signup_main_page}?rcplan=aws`;
    }

    if (marketPlace === 'gcp') {
      return `${systemParams.signup_main_page}?rcplan=gcp`;
    }

    return systemParams.signup_main_page;
  };

  const linkText = <LinkStyler.LinkContent>{t(keyPrefix.signUp)}</LinkStyler.LinkContent>;

  return (
    <S.DontHaveAnAccountText>
      {t(keyPrefix.dontHaveAccount)}
      <LinkStyler variant="inline">
        {systemParams?.signup_main_page ? (
          <a data-testid="link--sign-up" href={getSignUpLink()}>
            {linkText}
          </a>
        ) : (
          <Link data-testid="link--sign-up" to={routes.signUp}>
            {linkText}
          </Link>
        )}
      </LinkStyler>
    </S.DontHaveAnAccountText>
  );
};

export default DontHaveAnAccount;
